<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="customerFocusKeyList"
	dataKey="canvasKey"
	[paginator]="customerFocusKeyList && customerFocusKeyList.length > 25"
	[rows]="25"
	[showCurrentPageReport]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[25, 50, 100]"
	[globalFilterFields]="['sk', 'customerTokenItem.cardNumber']"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex p-grid">
			<div class="p-col-12 p-md-3"></div>
			<div class="p-col-12 p-md-3"></div>
			<div class="p-col-12 p-md-3">
				<span class="p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
						placeholder="Global Search"
					/>
				</span>
			</div>
			<div class="p-col-12 p-md-3">
				<div class="d-flex justify-content-end">
					<p-button pRipple styleClass="p-button-raised m-2" (click)="focusKeyNew()">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<th pSortableColumn="sk">
				Key ID
				<p-sortIcon field="sk"></p-sortIcon>
			</th>
			<th pSortableColumn="created">
				Date Added
				<p-sortIcon field="created"></p-sortIcon>
			</th>
			<th pSortableColumn="customerTokenItem.cardNumber">
				Linked Card Number
				<p-sortIcon field="customerTokenItem.cardNumber"></p-sortIcon>
			</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr>
			<td>
				<span class="p-column-title">Key ID</span>
				{{ rec.sk }}
			</td>
			<td>
				<span class="p-column-title">Date Added</span>
				{{ moment(rec.created).format("l LT") }}
			</td>
			<td>
				<span class="p-column-title">Linked Card Number</span>
				<span *ngIf="!rec.customerTokenItem"> No credit card attached </span>
				<span *ngIf="rec.customerTokenItem">
					{{ rec.customerTokenItem?.cardNumber }}
				</span>
			</td>
			<td style="text-align: right">
				<div>
					<p-button pRipple styleClass="p-button p-button-raised p-button-danger  m-2" (click)="focusKeyDelete(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</div>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="4" style="text-align: center">No Keys found.</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog
	*ngIf="customerFocusKeySelected"
	[visible]="customerFocusKeySelected"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
>
	<ng-template pTemplate="header"> Add new FocusKey </ng-template>
	<div class="d-flex">
		<span class="p-float-label m-2 flex-grow-1">
			<input pInputText type="text" id="nfcId" name="nfcId" [(ngModel)]="customerFocusKeySelected.sk" class="w-100" />
			<label for="nfcId">FocusKey ID</label>
		</span>
		<p-dropdown
			placeholder="Select CC..."
			[options]="customerTokenList"
			optionLabel="cardNumber"
			optionValue="token"
			name="customerTokenList"
			[(ngModel)]="customerFocusKeySelected.token"
			[style]="{ width: '100%' }"
			appendTo="body"
			styleClass="m-2"
		></p-dropdown>
	</div>
	<ng-template pTemplate="footer">
		<div class="d-flex justify-content-end">
			<p-button pRipple styleClass=" p-button-raised p-button-danger m-2" (click)="customerFocusKeySelected = undefined">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'window-close']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
			<p-button pRipple styleClass=" p-button-raised p-button-success m-2" (click)="focusKeyNewSave()" [disabled]="!customerFocusKeySelected.sk">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</ng-template>
</p-dialog>
